export default "__VITE_ASSET__BUAdwUpG__"